module.exports = __webpack_public_path__ + "static/media/kidFont.19f8aeb3.jpg";